import { SettingsGroup } from './settings-menu.model';

export function normalizeText(value: string): string {
    return (value ?? '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '');
}

export function filterSettingsGroups(groups: SettingsGroup[], term: string): SettingsGroup[] {
    const normalizedTerm = normalizeText(term).trim();
    if (!normalizedTerm) {
        return groups;
    }

    return groups
        .map((group) => {
            const groupMatches = normalizeText(group.label).includes(normalizedTerm);
            const items = groupMatches
                ? group.items
                : group.items.filter((item) => normalizeText(item.label).includes(normalizedTerm));
            return { label: group.label, items };
        })
        .filter((group) => group.items.length > 0);
}
